// src/api/index.js
const API_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

// Central function — all calls to Apps Script go through here
async function callAPI(action, data = {}) {
  const { auth } = await import('../firebase');
  const user = auth.currentUser;

  if (!user) throw new Error('Not authenticated');

  const token = await user.getIdToken();

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ action, token, data })
  });

  const result = await response.json();

  if (result.status !== 200) {
    throw new Error(result.error || 'API error');
  }

  return result;
}

// ── Auth ────────────────────────────────────────────────────
export const getMemberByEmail  = (email) =>
  callAPI('getMemberByEmail', { email });

export const markFirstLoginComplete = () =>
  callAPI('markFirstLoginComplete');

// ── Members ─────────────────────────────────────────────────
export const getMemberProfile  = (memberId) =>
  callAPI('getMemberProfile', { memberId });

export const updateMemberProfile = (data) =>
  callAPI('updateMemberProfile', data);

export const getMemberDirectory = () =>
  callAPI('getMemberDirectory');

// ── Dues ────────────────────────────────────────────────────
export const getDuesForMember = (memberId) =>
  callAPI('getDuesForMember', { memberId });

export const getHouseAggregateDues = (boardingHouse) =>
  callAPI('getHouseAggregateDues', { boardingHouse });

export const getAllDuesDashboard = () =>
  callAPI('getAllDuesDashboard');

// ── Payments ────────────────────────────────────────────────
export const updatePayment = (data) =>
  callAPI('updatePayment', data);

// ── Content ─────────────────────────────────────────────────
export const getAnnouncements = () =>
  callAPI('getAnnouncements');

export const postAnnouncement = (data) =>
  callAPI('postAnnouncement', data);

export const getActivities = () =>
  callAPI('getActivities');

export const postActivity = (data) =>
  callAPI('postActivity', data);

export const getOpportunities = () =>
  callAPI('getOpportunities');

export const postOpportunity = (data) =>
  callAPI('postOpportunity', data);

export const getFundraising = () =>
  callAPI('getFundraising');

export const createFundraisingCampaign = (data) =>
  callAPI('createFundraisingCampaign', data);

// ── Notifications ───────────────────────────────────────────
export const getUpcomingBirthdays = () =>
  callAPI('getUpcomingBirthdays');
export const getMembersForManagement = () =>
  callAPI('getMembersForManagement');